(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["airu-bundle-selector"] && !Shopify.designMode) return;
  try {
    class AiruBundleSelector extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.busy = false;
      this.form = this.closest('form');
      this.section = this.closest('.shopify-section');
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
        style: 'currency', currency: this.dataset.currency
      });
      for (const select of this.querySelectorAll('select')) {
        if (!select.selectedOptions[0] || select.selectedOptions[0].disabled) {
          const available = Array.from(select.options).find(option => !option.disabled);
          if (available) select.value = available.value;
        }
      }
      this.addEventListener('change', () => this.update(), { signal: this.controller.signal });
      this.hidden = false;
      this.update();
    }
    disconnectedCallback() { this.controller?.abort(); }
    update() {
      for (const card of this.querySelectorAll('[data-offer]')) {
        const selected = card.querySelector('input').checked;
        const selects = Array.from(card.querySelectorAll('select'));
        card.querySelector('.airu-bundle-scents').hidden = !selected;
        for (const select of selects) select.disabled = !selected || this.busy;
        const regular = selects.reduce((sum, select) => sum + Number(select.selectedOptions[0]?.dataset.price || 0), 0);
        const total = regular - (card.dataset.offer === '1' ? 0 : 1000);
        card.querySelector('[data-total]').textContent = this.money.format(total / 100);
        const compare = card.querySelector('[data-regular]');
        if (compare) compare.textContent = this.money.format(regular / 100);
        if (selected) {
          this.activeCard = card;
          const available = selects.every(select => select.selectedOptions[0] && !select.selectedOptions[0].disabled);
          const button = this.form.querySelector('[ref="addToCartButton"]');
          if (button) button.disabled = this.busy || !available;
          const sticky = this.section?.querySelector('sticky-add-to-cart');
          const stickyPrice = sticky?.querySelector('.sticky-add-to-cart__price');
          const stickyTitle = sticky?.querySelector('.sticky-add-to-cart__title');
          const stickyButton = sticky?.querySelector('[ref="addToCartButton"]');
          if (stickyPrice) stickyPrice.textContent = this.money.format(total / 100);
          if (stickyTitle) stickyTitle.textContent = card.querySelector('[data-offer-title]').textContent;
          if (stickyButton) stickyButton.disabled = this.busy || !available;
        }
      }
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy) return;
      const selections = Array.from(this.activeCard.querySelectorAll('select'));
      if (selections.some(select => !select.selectedOptions[0] || select.selectedOptions[0].disabled)) return;
      const quantities = new Map();
      for (const select of selections) quantities.set(select.value, (quantities.get(select.value) || 0) + 1);
      const items = Array.from(quantities, ([id, quantity]) => ({ id, quantity }));
      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      this.querySelector('.airu-bundle-error').hidden = true;
      for (const radio of this.querySelectorAll('input[type="radio"]')) radio.disabled = true;
      this.update();
      const liveRegion = this.closest('product-form-component')?.querySelector('[ref="liveRegion"]');
      if (liveRegion) liveRegion.textContent = this.dataset.adding;
      try {
        const response = await fetch(this.dataset.addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.error);
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        const message = error instanceof TypeError ? this.dataset.error : error.message;
        this.querySelector('[data-error-message]').textContent = message;
        this.querySelector('.airu-bundle-error').hidden = false;
        if (liveRegion) liveRegion.textContent = message;
        this.busy = false;
        this.removeAttribute('aria-busy');
        for (const radio of this.querySelectorAll('input[type="radio"]')) radio.disabled = false;
        this.update();
      }
    }
  }
  if (!customElements.get('airu-bundle-selector')) customElements.define('airu-bundle-selector', AiruBundleSelector);
  } catch(e) { console.error(e); }
})();

})();
